import { WorkModel } from '@Entities/work/work'
import './index.scss'
import React from 'react'
import StatusPill from '@Components/StatusPills/StatusPill'
import HoldStatusIndicator from '@Components//StatusPills/HoldStatusIndicator'
import PublicDomainToolTip from '@Components/WorkItemPillSection/PublicDomainToolTip'
import NonMusicalToolTip from '@Components/WorkItemPillSection/NonMusicalToolTip'
import { OverclaimViewModel } from '@Entities/overclaim/overclaim-view'
import OverclaimStatusIndicator from '@Components/StatusPills/OverclaimStatusIndicator'
import { isNonMusicalWork, isWorkPublicDomain } from '@App/helpers/work-entities/utils/work-flag-helpers'

interface WorkItemPillSectionProps {
    work: WorkModel | OverclaimViewModel
    showOverclaimStatus?: boolean
}

const WorkItemPillSection = (props: WorkItemPillSectionProps) => {
    const { work, showOverclaimStatus } = props
    const isPublicDomain = work.isPublicDomain || isWorkPublicDomain(work)
    const isNonMusical = work.isNonMusical || isNonMusicalWork(work)
    const showDraft = !work.isComplete && !work.overclaimHeaderId

    const isThereAnyPillToShow =
        (work.holdTypeId && !showOverclaimStatus) ||
        (work.overclaimStatusFilter && showOverclaimStatus) ||
        isPublicDomain ||
        isNonMusical ||
        showDraft

    return isThereAnyPillToShow ? (
        <div className="status-container">
            {!!work.holdTypeId && !showOverclaimStatus && <HoldStatusIndicator holdStatus={work.holdTypeId} />}
            {work.overclaimStatusFilter && showOverclaimStatus && (
                <OverclaimStatusIndicator overclaimStatus={work.overclaimStatusFilter} />
            )}
            {isPublicDomain && <StatusPill color="blue" tooltip={<PublicDomainToolTip />} />}
            {isNonMusical && <StatusPill color="blue" tooltip={<NonMusicalToolTip />} />}
            {showDraft && <StatusPill text="Draft" color="blue" />}
        </div>
    ) : null
}

export default WorkItemPillSection
